import { combineReducers } from 'redux';
import {
  UPDATE_RESIDENT,
  UPDATE_INVESTMENT_YEARS,
  UPDATE_INVESTMENT_PROFILE,
  UPDATE_TEMPORARY_DROP_PERCENTAGE,UPDATE_ADDRESSLINE
} from './actionsTypes';
import loginTokenReducer from '../loginTokenSlice';

const residentReducer = (state = '', action) => {
  if (action.type === UPDATE_RESIDENT) {
    return action.payload;
  }
  return state;
};

const investmentYearsReducer = (state = '', action) => {
  if (action.type === UPDATE_INVESTMENT_YEARS) {
    return action.payload;
  }
  return state;
};

const investmentProfileReducer = (state = '', action) => {
  if (action.type === UPDATE_INVESTMENT_PROFILE) {
    return action.payload;
  }
  return state;
};

const temporaryDropPercentageReducer = (state = '', action) => {
  if (action.type === UPDATE_TEMPORARY_DROP_PERCENTAGE) {
    return action.payload;
  }
  return state;
};
const fullAddressReducer = (state = '', action) => {
  if (action.type === UPDATE_ADDRESSLINE) {
    return action.payload;
  }
  return state;
};

const rootReducer = combineReducers({
  resident: residentReducer,
  investment_years: investmentYearsReducer,
  investment_profile: investmentProfileReducer,
  temporary_drop_percentage_portfolio: temporaryDropPercentageReducer,
  fullAddress: fullAddressReducer,
  loginToken: loginTokenReducer,
  
});

export default rootReducer;
